


import React from "react";
import {
  Card,
  DataTable,
  Text,
  Badge,
  BlockStack,
  Spinner,
  EmptyState,
} from "@shopify/polaris";

const InquiriesTable = ({ products, indexing = 1 }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date);
  };

  const formatTime = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(date);
  };
  const rows = products?.map((item, index) => [
    index + 1 + (indexing - 1) * 20, 
    <BlockStack gap="100">
      <Text variant="bodyMd" fontWeight="bold" as="span">
        {item.customer?.name || "—"}
      </Text>
      <Text variant="bodySm" tone="subdued" as="span">
        {item.customer?.email || "—"}
      </Text>
    </BlockStack>,
    item.customer?.mobile || "—",
    <BlockStack gap="100">
      <Text variant="bodyMd" as="span">
        {formatDate(item.createdAt)}
      </Text>
      <Text variant="bodySm" tone="subdued" as="span">
        {formatTime(item.createdAt)}
      </Text>
    </BlockStack>,
    item.customer?.storeCode || "—",
    item.productName || "—",
    <Badge tone="info" size="small">
      {item.productSku || "—"}
    </Badge>,
  ]) || [];

  const columnContentTypes = [
    "text",
    "text",
    "text", 
    "text", 
    "text",
    "text", 
    "text", 
  ];

  const headings = [
    "SN",
    "Name & Email",
    "Phone",
    "Date",
    "Store Code",
    "Product Name",
    "SKU ID",
  ];

  return (
    <Card>
      {products?.length > 0 ? (
        <DataTable
          columnContentTypes={columnContentTypes}
          headings={headings}
          rows={rows}
          hoverable
          increasedTableDensity 
          stickyHeader
          verticalAlign="middle"
        />
      ) : (
        <div className="py-12">
          {products === undefined ? (
            <BlockStack align="center" inlineAlign="center" gap="400">
              <Spinner accessibilityLabel="Loading inquiries" size="large" />
              <Text variant="bodyMd" tone="subdued">
                Loading inquiries...
              </Text>
            </BlockStack>
          ) : (
            <EmptyState
              heading="No inquiries found"
              image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
            >
              <p>There are no customer inquiries at the moment.</p>
            </EmptyState>
          )}
        </div>
      )}
    </Card>
  );
};

export default InquiriesTable;